module.exports = __webpack_public_path__ + "img/gift_brown.ecb00df2.svg";